<template>
  <div>
    <div>
      <input type="file"
             ref="fileInput"
             @change="upload"
             hidden />
      <button class="btn btn-primary btn-extra-round"
              @click="$refs.fileInput.click()">
        Auto Config
      </button>
    </div>
  </div>
</template>
<script>
    import uploadConfig from "@mixins/upload-local";

    export default {
        methods: {
            upload() {
                this.uploadConfig({
                    advertisingId: this.dataParentId,
                    file: this.$refs.fileInput.files[0]
                })
            },
        },
        mixins: [uploadConfig]
    }
</script>

<style lang = "scss" scoped >
.btn {
  margin: 15px;
}
</style>
